module.exports = __webpack_public_path__ + "img/logo-bigpicture-poweredby-negative.97db0848.svg";